import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withProps, compose, branch, renderNothing, withHandlers } from 'recompose'
import { getDisplayName } from 'shared-web/src/helpers/CustomerHelpers'

import * as PlaybookActions from 'app/modules/playbook/actions'
import * as PlaybookSelectors from 'app/modules/playbook/selectors'
import * as UserSelectors from 'app/modules/user/selectors'

import EmailMessage from './component'

const mapStateToProps = state => ({
  orgUsers: UserSelectors.currentOrgUsersAlphabetical(state),
  emailMessage: PlaybookSelectors.emailMessage(state),
  isMarketingSequencePlaybook: PlaybookSelectors.getIsMarketingSequencePlaybook(state),
  dynamicAccountSendAttribute: PlaybookSelectors.dynamicAccountSendAttribute(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      setSenderName: PlaybookActions.setSenderName,
      setMessage: PlaybookActions.setMessage,
      setHeadline: PlaybookActions.setHeadline,
      setAuthorId: PlaybookActions.setAuthorId,
      setEmailOverride: PlaybookActions.setEmailOverride,
    },
    dispatch
  ),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  branch(({ orgUsers }) => !orgUsers.size, renderNothing),
  withProps(props => ({
    message: props.emailMessage.message,
    headline: props.emailMessage.title,
    selectedValue: props.emailMessage.senderEmailOverride,
  })),
  withHandlers({
    renderSelectedUser: props => option => {
      const selectedUser = props.orgUsers.find(user => user.id === option.value.value)
      return (
        <div className="Select-value">
          <span className="Select-value-label">{!!selectedUser ? selectedUser.email : option.value.value}</span>
        </div>
      )
    },
  })
)(EmailMessage)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/EmailMessage/index.js